


import  types from "../actions/actionTypes";
import initialState from "./initialState";

export default function sitesReducer(state = initialState.sites, action) {

    const mergeInSite = (sites, siteUpdate) => {
        if (siteUpdate.id < 1) {
            return sites;
        }
        const sitesMinusStaleData = sites.filter(site => site.id !== siteUpdate.id);       
        return sitesMinusStaleData.concat(siteUpdate);
    }

     const deleteSite = (current, id) => {
        return current.filter(site => site.id !== id);
    } 


    switch (action.type) {
        case types.LOAD_SITE_SUCCESS:
        case types.UPDATED_SITE_SUCCESS:
            return mergeInSite(state, action.site);
            case types.DELETED_SITE:      
            return deleteSite(state, action.id);      
        case types.DELETED_SITE_INCOMING:  
        case types.UPDATED_SITE_INCOMING:
            return deleteSite(state, action.payload);    
        default:
            return state;
    }
}

